import React, {useState} from 'react'
import {useDispatch, useSelector} from "react-redux";
import {applyHotspotChanges, updateHotspot} from "../../actions";
import axios from "axios";
import classNames from "classnames";
import AjaxButton from "src/shared/form/ajax_button";
import _ from "lodash";
import Chat from "./chat";
import GroupChat from "./group_chat";
import Text from "./text";
import Downloads from "./downloads";
import Redirect from "./redirect";
import ImageMapRedirect from "./image_map_redirect";
import Iframe from "./iframe";
import Hidden from "./hidden";
import SupportChat from "./support_chat";
import LeadGeneration from "./lead_generation";

const getHotspotModule = (slideshowImage, setUpdatedSlideshowImage) => {
  switch (slideshowImage?.data?.kind) {
    // key is important so the component gets rerendered for different hotspots
    case "chat":
      return <Chat key={slideshowImage.id}
                   initialState={slideshowImage.data?.chatData || ""}
                   onDataChanged={(data) => setUpdatedSlideshowImage({
                     ...slideshowImage,
                     data: {
                       ...slideshowImage.data,
                       chatData: data
                     }
                   })}/>
    case "group_chat":
      return <GroupChat key={slideshowImage.id}
                        initialState={slideshowImage.data?.groupChatData || ""}
                        onDataChanged={(data) => setUpdatedSlideshowImage({
                          ...slideshowImage,
                          data: {
                            ...slideshowImage.data,
                            groupChatData: data
                          }
                        })}
      />
    // case "video":
    //   return <Video key={slideshow_image.id} hotspot={slideshow_image}/>
    case "text":
      return (
        <>
          <h5 className="hotspot-setting-header">Title</h5>
          <input
            className="form-control"
            type="text"
            placeholder="Sets the title for the popup."
            value={slideshowImage && slideshowImage.data.title ? slideshowImage.data.title : ""}
            onChange={(event) => {
              setUpdatedSlideshowImage({
                ...slideshowImage,
                data: {
                  ...slideshowImage.data,
                  title: event.target.value
                }
              })
            }}
          />
          <Text key={slideshowImage.id}
                     initialState={slideshowImage.data?.textData || ""}
                     onDataChanged={(data) => setUpdatedSlideshowImage({
                       ...slideshowImage,
                       data: {
                         ...slideshowImage.data,
                         textData: data
                       }
                     })}
        />
      </>)
    case "downloads":
      return <Downloads key={slideshowImage.id} hotspot={slideshowImage}/>
    case "redirect":
      return <Redirect key={slideshowImage.id}
                       value={{
                         redirect_url: slideshowImage.data.redirect_url,
                         redirect_in_same_window: slideshowImage.data.redirect_in_same_window
                       }}
                       onDataChanged={(value) => {
                         setUpdatedSlideshowImage({
                           ...slideshowImage,
                           data: {
                             ...slideshowImage.data,
                             ...value
                           }
                         })
                       }}
      />
    case "image_map_id":
      return <ImageMapRedirect key={slideshowImage.id}
                               value={slideshowImage.data.image_map_redirect_id}
                               onDataChanged={(event) => {
                                 setUpdatedSlideshowImage({
                                   ...slideshowImage,
                                   data: {
                                     ...slideshowImage.data,
                                     image_map_redirect_id: event.target.value
                                   }
                                 })
                               }}/>
    case "iframe":
      return <Iframe key={slideshowImage.id}
                     value={slideshowImage.data.iframe_html}
                     onDataChanged={(event) => {
                       setUpdatedSlideshowImage({
                         ...slideshowImage,
                         data: {
                           ...slideshowImage.data,
                           iframe_html: event.target.value
                         }
                       })
                     }}
      />
    case "lead_generation":
      return <LeadGeneration key={slideshowImage.id}
                   initialState={slideshowImage.data?.leadGenerationData || ""}
                   onDataChanged={(data) => setUpdatedSlideshowImage({
                     ...slideshowImage,
                     data: {
                       ...slideshowImage.data,
                       leadGenerationData: data
                     }
                   })}/>
    case "hidden":
      return <Hidden key={slideshowImage.id}/>
    case "support_chat":
      return <SupportChat key={slideshowImage.id}/>
    default:
      return <div>Please select a type to continue.</div>
  }
}

export default function SlideShow(props) {
  const {id} = props.hotspot
  const slideshowImages = useSelector(state => state.imageHotspotSlideshowImages.filter(si => si.image_hotspot_id == id))
  const sortedSlideshowImages = _.sortBy(slideshowImages, ["position", "filename", "id"], ["asc", "asc", "asc",])

  const dispatch = useDispatch()

  const slideshowImageUrl = useSelector((state) => state.slideshowImageUrl)
  const reorderSlideshowImageUrl = useSelector((state) => state.reorderSlideshowImageUrl)
  const hotspotUpdateData = useSelector((state) => state.hotspotUpdateData)
  const account = useSelector((state) => state.account)

  const hasUnsavedHotspotChanges = !_.isEmpty(hotspotUpdateData)

  // References the object containing all data concerning a slideshow image.
  const [selectedSlideshowImage, setSelectedSlideshowImage] = useState({});
  // References the actual image file one might upload.
  const [selectedUploadImage, setSelectedUploadImage] = useState(null);

  // Stores updated data of a slideshow image.
  const [updatedSlideshowImage, setUpdatedSlideshowImage] = useState(null);
  const hasUnsavedSlideshowImageChanges = updatedSlideshowImage != null

  // If not updated the original slideshow image otherwise the updated one
  const currentSlideshowImage = updatedSlideshowImage || selectedSlideshowImage

  const saveFile = () => {
    const isUpdate = currentSlideshowImage && currentSlideshowImage.id
    const data = new FormData()
    data.append("hotspot_id", id)
    data.append("file", selectedUploadImage)
    data.append("data", JSON.stringify(currentSlideshowImage.data))
    if (currentSlideshowImage?.id) {
      data.append("slideshow_image_id", currentSlideshowImage.id)
    }

    axios({
      method: isUpdate ? "put" : "post",
      url: isUpdate ? slideshowImageUrl : slideshowImageUrl,
      data: data
    }).then(
      (data) => {
        if (data.data.status === "OK") {
          clearFormData()
          dispatch(updateHotspot(data.data.image_hotspot))
          dispatch(applyHotspotChanges())
        } else {
          alert(data.data.message || "A error occurred while updating.")
        }
      },
      (error) => {
        console.error(error)
        alert(error)
      }
    ).then(function () {
      console.log("done")
    });
  }

  const clearFormData = () => {
    setSelectedUploadImage(null)
    setSelectedSlideshowImage({})
    setUpdatedSlideshowImage(null)
  }

  const selectSlideShowImage = (slideshowImage) => {
    setUpdatedSlideshowImage(null)
    setSelectedSlideshowImage(slideshowImage)
    setSelectedUploadImage(null)
  }

  if (hasUnsavedHotspotChanges) {
    return <>
      <h5 className="hotspot-setting-header">Unsaved changes</h5>
      <div className="hotspot-setting-info">
        You first need to save your changes bevore you can continue adding slideshow items.
      </div>
    </>
  }

  const canUploadFile = !sortedSlideshowImages || sortedSlideshowImages.length < 20

  let slideshowImageContent = null
  // Already uploaded slideshow images
  if (sortedSlideshowImages && sortedSlideshowImages.length > 0) {
    slideshowImageContent = <>
      {sortedSlideshowImages.map((slideShowImage, index) => {
        console.log({slideShowImage})
        return <div className="row" key={slideShowImage.id}>
          <div className="col-12">
            <hr/>
          </div>
          <div className="col-12 col-md-8">
            <div className="row">
              <div className="col-12">
                <img className="img-responsive img-thumbnail" src={slideShowImage.url}/>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-4 d-flex justify-content-end">
            {index > 0 ? <AjaxButton
              method="put"
              className={"btn media-file-btn"}
              icon={"fa-arrow-up"}
              url={reorderSlideshowImageUrl}
              onSuccess={(data) => {
                if (data.data.status === "OK") {
                  clearFormData()
                  dispatch(updateHotspot(data.data.image_hotspot))
                  dispatch(applyHotspotChanges())
                } else {
                  alert(data.data.message || "A error occurred while deleting.")
                }
              }}
              data={{
                hotspot_id: id,
                slideshow_image_id: slideShowImage.id,
                direction: "UP"
              }}/> : null}
            {index + 1 < sortedSlideshowImages.length ? <AjaxButton
              method="put"
              className={"btn media-file-btn"}
              icon={"fa-arrow-down"}
              url={reorderSlideshowImageUrl}
              onSuccess={(data) => {
                if (data.data.status === "OK") {
                  clearFormData()
                  dispatch(updateHotspot(data.data.image_hotspot))
                  dispatch(applyHotspotChanges())
                } else {
                  alert(data.data.message || "A error occurred while deleting.")
                }
              }}
              data={{
                hotspot_id: id,
                slideshow_image_id: slideShowImage.id,
                direction: "DOWN"
              }}/> : null}
            <AjaxButton
              method="delete"
              className={"btn media-file-btn"}
              icon={"fa-trash"}
              url={slideshowImageUrl}
              onSuccess={(data) => {
                if (data.data.status === "OK") {
                  clearFormData()
                  dispatch(updateHotspot(data.data.image_hotspot))
                  dispatch(applyHotspotChanges())
                } else {
                  alert(data.data.message || "A error occurred while deleting.")
                }
              }}
              data={{
                hotspot_id: id,
                slideshow_image_id: slideShowImage.id
              }}/>
          </div>
          <div className="col-12">
            <button
              className={classNames("btn btn-sm btn-outline-success btn-ueg float-right")}
              type="button"
              onClick={() => selectSlideShowImage(slideShowImage)}
            >
              Edit
            </button>
          </div>
        </div>
      })}
    </>
  }

  const isUpdate = currentSlideshowImage && currentSlideshowImage.id

  return <div>
    {canUploadFile ? <>
      <hr/>
      <div className="row">
        <div className={"col-12" + currentSlideshowImage?.id ? " col-md-8" : ""}>
          <h5 className="hotspot-setting-header">
            {currentSlideshowImage?.id ? "Edit slideshow item" : "Add a slideshow item"}
          </h5>
          <div className="hotspot-setting-info">
            {currentSlideshowImage?.id ? "You currently have a slideshow item selected, which you are editing." : "Just add a slideshow item below."}
          </div>
        </div>
        {currentSlideshowImage?.id ? <div className={"col-12 col-md-4 d-flex justify-content-end"}>
          <button
            className={classNames("btn media-file-btn")}
            type="button"
            onClick={() => clearFormData()}
          >
            {"Exit edit mode "}
            <i className="fa fa-times"/>
          </button>
        </div> : null}
      </div>


      {currentSlideshowImage ? <div className="row">
        <div className="col-12">
          <img className="img-responsive" src={currentSlideshowImage.url}/>
        </div>
      </div> : null}

      {/*<div className="form-group">*/}
      {/*  <label htmlFor="displayTime">Display Time</label>*/}
      {/*  <input className="form-control"*/}
      {/*         id="displayTime"*/}
      {/*         type="number"*/}
      {/*         value={currentSlideshowImage?.data?.displayTime || 5}*/}
      {/*         onChange={(event) => {*/}
      {/*           setUpdatedSlideshowImage({*/}
      {/*             ...currentSlideshowImage,*/}
      {/*             data: {*/}
      {/*               ...currentSlideshowImage?.data,*/}
      {/*               displayTime: event.target.value*/}
      {/*             }*/}
      {/*           })*/}
      {/*         }}*/}
      {/*  />*/}
      {/*  <small className="form-text text-muted">The time this image is displayed in seconds.</small>*/}
      {/*</div>*/}

      <div className="form-group">
        <label htmlFor="hotspotType">Type</label>
        <select className="form-control"
                id="hotspotType"
                value={currentSlideshowImage?.data?.kind || "hidden"}
                onChange={(event) => {
                  console.log("event.target.value", event.target.value)
                  setUpdatedSlideshowImage({
                    ...currentSlideshowImage,
                    data: {
                      ...currentSlideshowImage?.data,
                      kind: event.target.value
                    }
                  })
                }}>
          <option value="hidden">Hidden</option>
          <option value="text">Text</option>
          <option value="redirect">Redirect</option>
          {account.backend_permission && <option value="iframe">IFrame</option>}
          {account.backend_permission && <option value="iframe">RAW HTML</option>}
          {account.backend_permission && <option value="image_map_id">Image Map</option>}
          {false &&
            <>
              <option value="chat">Video Chat</option>
              <option value="group_chat">Group Chat</option>
              <option value="image_map_id">Image Map</option>
              <option value="support_chat">Support Chat</option>
            </>
          }
        </select>
        <small id="hotspotTypeHelpBlock" className="form-text text-muted">
          By setting the type, you define what will be shown, when a user clicks the slide. Each slide will be shown for 5 seconds each.
        </small>
      </div>

      {getHotspotModule(currentSlideshowImage, setUpdatedSlideshowImage)}

      <hr/>
      <div className="custom-file">
        <input type="file"
               className="custom-file-input"
               id="download_item_file"
               required
               onChange={e => setSelectedUploadImage(e.target.files[0])}
        />
        <label className="custom-file-label"
               htmlFor="download_item_file">{selectedUploadImage?.name || "Choose file..."}</label>
      </div>

      {updatedSlideshowImage || selectedUploadImage ? <>


        <AjaxButton
          method={(isUpdate) ? "put" : "post"}
          labelSending="Saving..."
          className={classNames("btn btn-outline-success btn-ueg mt-3")}
          icon="fa-save"
          url={slideshowImageUrl}
          data={() => {
            const data = new FormData()
            data.append("hotspot_id", id)
            data.append("image", selectedUploadImage)
            data.append("data", JSON.stringify(currentSlideshowImage.data || {}))
            if (currentSlideshowImage?.id) {
              data.append("slideshow_image_id", currentSlideshowImage.id)
            }

            return data
          }}
          label={"Save file"}
          onSuccess={(data) => {
            if (data.data.status === "OK") {
              clearFormData()
              dispatch(updateHotspot(data.data.image_hotspot))
              dispatch(applyHotspotChanges())
            } else {
              alert(data.data.message || "A error occurred while updating.")
            }
          }}
          onError={(error) => {
            console.error(error)
            alert(error)
          }}
        />
      </> : null}
    </> : <div>There are no files uploaded yet.</div>}

    {!updatedSlideshowImage && slideshowImageContent ? <>
      <hr/>
      <h5 className="hotspot-setting-header">Images</h5>
      <div className="hotspot-setting-info">
        Below you see your already uploaded images.
      </div>
    </> : null}
    {updatedSlideshowImage ? null : slideshowImageContent}
  </div>;
}
